// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__39LpP","info":"UpdateTermsInfo_info__5sHzv"};